import { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';

import ModalsContext from 'app/contexts/ModalsContext';
import useCreditCardManagement from 'app/hooks/useCreditCardManagement';

const AddCreditCardStep = ({ currentUser, afterCancel, afterSuccess }) => {
  const { openModal } = useContext(ModalsContext);
  const onTryAgainSuccess = afterSuccess;
  const onManageCardsSuccess = afterSuccess;
  const onCloseClickCallback = afterCancel;
  const onAddToBalanceSuccess = afterSuccess;

  const {
    openManageCardsModal,
  } = useCreditCardManagement({
    openModal,
    currentUser,
    guard: null,
    setGuard: null,
    onTryAgainSuccess,
    onManageCardsSuccess,
    onAddToBalanceSuccess,
  });

  useEffect(() => {
    openManageCardsModal(false, onCloseClickCallback);
  }, []);

  return null;
};

AddCreditCardStep.propTypes = {
  afterCancel: PropTypes.func.isRequired,
  afterSuccess: PropTypes.func.isRequired,
  currentUser: PropTypes.object.isRequired,
};

export default AddCreditCardStep;
